import { render } from "./ColorsPage.vue?vue&type=template&id=d5f8e4b4&ts=true"
import script from "./ColorsPage.vue?vue&type=script&lang=ts"
export * from "./ColorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__